var React = require('react');

function CheckmarkPurple (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_15268_829)","key":0},[React.createElement("path",{"d":"M8.14551 16.6367C12.5638 16.6367 16.1455 13.055 16.1455 8.63672C16.1455 4.21844 12.5638 0.636719 8.14551 0.636719C3.72723 0.636719 0.145508 4.21844 0.145508 8.63672C0.145508 13.055 3.72723 16.6367 8.14551 16.6367Z","fill":"#F5F0FF","key":0}),React.createElement("path",{"d":"M4 8.60218L6.38037 11.3716L12.3405 6","stroke":"#A494FF","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_15268_829"},React.createElement("rect",{"width":"16","height":"16","fill":"white","transform":"translate(0.145508 0.636719)"})))]);
}

CheckmarkPurple.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = CheckmarkPurple;

CheckmarkPurple.default = CheckmarkPurple;
